import React from 'react';

import { TextField } from '@mui/material';
import _ from 'lodash';
import Joi from 'joi';
import { tlds } from '@hapi/tlds';

import { OhsFormFieldBaseProps } from '../services/OhsFormModels';
import OhsFormFieldLayout from '../components/OhsFormFieldLayout';
import { returnFieldStyle, returnVariant } from '../components/OhsFieldLayout';

export interface Props extends OhsFormFieldBaseProps {}

function InputEle(props: Props) {
  const error = _.get(props.ohsFormSettings.useFormMethods.formState.errors, props.id);
  return (
    <TextField
      type="email"
      error={error != null}
      fullWidth
      margin="dense"
      inputProps={{ 'data-testid': props.id }}
      InputLabelProps={{
        shrink: true,
      }}
      size="small"
      variant={returnVariant(props.ohsFormSettings.layout)}
      placeholder={props?.placeholder}
      required={props.required}
      disabled={props.disabled}
      {...props.ohsFormSettings.useFormMethods.register(props.id, {
        required: props.required,
        validate: {
          isEmail: (emailValue: any) => {
            if (props.required !== true && _.isEmpty(emailValue)) {
              return true;
            }
            // Validate email - same as backend validator
            const schema = Joi.string().email({ tlds: { allow: tlds } });
            const { error: isInvalidEmail } = schema.validate(emailValue);

            return isInvalidEmail === undefined;
          },
        },
      })}
      style={returnFieldStyle(props.ohsFormSettings.layout)}
    />
  );
}

export default function OhsEmailField(props: Props) {
  return <OhsFormFieldLayout {...props} inputEle={<InputEle {...props} />} />;
}
